import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../contexts/AuthContext';
import './Sidebar.css';

const Sidebar: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { logout } = useAuth();
  const isActive = (path: string) => location.pathname === path;

  const handleLogoutClick = () => {
    if (window.confirm(t('common.logoutConfirm'))) {
      logout();
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <Link to="/dashboard" className="sidebar-logo">
          <img 
            src="/images/CRYPXA_Dashboard_sidebar_Logo.png" 
            alt="Crypxa Logo" 
            className="sidebar-logo-img"
          />
        </Link>
      </div>

      <nav className="sidebar-nav">
        <Link to="/dashboard" className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
          <i className="fas fa-home"></i>
          <span>{t('sidebar.dashboard')}</span>
        </Link>
        <Link to="/dashboard/trade" className={`nav-item ${isActive('/dashboard/trade') ? 'active' : ''}`}>
          <i className="fas fa-exchange-alt"></i>
          <span>{t('sidebar.trade')}</span>
        </Link>
        <Link to="/dashboard/swap-history" className={`nav-item ${isActive('/dashboard/swap-history') ? 'active' : ''}`}>
          <i className="fas fa-list-alt"></i>
          <span>{t('sidebar.tradeHistory')}</span>
        </Link>
        <Link to="/dashboard/predictions" className={`nav-item ${isActive('/dashboard/predictions') || isActive('/dashboard/ai-prediction') || isActive('/dashboard/ml-prediction') || isActive('/dashboard/candle-prediction') ? 'active' : ''}`}>
          <i className="fas fa-chart-line"></i>
          <span>{t('sidebar.predictions')}</span>
        </Link>
        <Link to="/dashboard/alerts" className={`nav-item ${isActive('/dashboard/alerts') ? 'active' : ''}`}>
          <i className="fas fa-bell"></i>
          <span>{t('sidebar.alerts')}</span>
        </Link>
        <Link to="/dashboard/historical-price" className={`nav-item ${isActive('/dashboard/historical-price') ? 'active' : ''}`}>
          <i className="fas fa-history"></i>
          <span>{t('sidebar.historicalPrices')}</span>
        </Link>
        <Link to="/dashboard/coin-comparison" className={`nav-item ${isActive('/dashboard/coin-comparison') ? 'active' : ''}`}>
          <i className="fas fa-balance-scale"></i>
          <span>{t('sidebar.coinComparison')}</span>
        </Link>
        <Link to="/dashboard/subscription" className={`nav-item ${isActive('/dashboard/subscription') ? 'active' : ''}`}>
          <i className="fas fa-credit-card"></i>
          <span>{t('sidebar.subscription')}</span>
        </Link>
        <Link to="/dashboard/settings" className={`nav-item ${isActive('/dashboard/settings') ? 'active' : ''}`}>
          <i className="fas fa-cog"></i>
          <span>{t('sidebar.settings')}</span>
        </Link>
      </nav>

      <div className="sidebar-footer">
        <button type="button" className="sidebar-logout-btn" onClick={handleLogoutClick} aria-label={t('nav.logout')}>
          <i className="fas fa-sign-out-alt"></i>
          <span>{t('sidebar.logout')}</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;

